import {Loader, LoaderOptions} from 'google-maps';
// import { Loader } from 'google-maps';
import loadGoogleMapsApi from 'load-google-maps-api';
import Swiper, { EffectFade, Pagination, Navigation } from 'swiper';
import axios from 'axios'

/** TODO: When we fail to get a certain categoru (504), we should try again at the end of the loop. */
export default class {
	loaded = false;
    /**
     * Map that shows location of embankment and key hill
     * and there distancies to local amenities.
     */
    constructor(el) {
		this.map_el = document.querySelector(el);
		this.cats =	["food", "drink", "travel", "shopping", "leisure", "culture", "education"]
		this.data = {};
		/** Active HTML markers. */
		this.active_markers = [];
		this.selected_categories = [];
		//lazy load the map
		if(this.map_el) {
			const offset = 1000;
			window.addEventListener('scroll', () => {
				if (this.loaded === false &&
					window.scrollY > this.map_el.offsetTop - window.innerHeight - offset
				) {
					console.log('loading map');
					this.loaded = true;
					this.init();
				}
			});
		}
		// this.init(el);
    }

    async init() {
		if(this.map_el) {
			if(!this.map_el.dataset.location) {
				throw new Error("map.js - You have forgot to set data-location");
			}

			if(!this.map_el.dataset.page) {
				throw new Error("map.js - You have forgot to set data-page");
			}

			if(!this.map_el.dataset.lat) {
				throw new Error("map.js - You have forgot to set data-lat");
			}

			if(!this.map_el.dataset.lng) {
				throw new Error("map.js - You have forgot to set data-lng");
			}

			if(!this.map_el.dataset.centerLat) {
				throw new Error("map.js - You have forgot to set data-center-lat");
			}

			if(!this.map_el.dataset.centerLng) {
				throw new Error("map.js - You have forgot to set data-center-lat");
			}

			if(!this.map_el.dataset.title) {
				throw new Error("map.js - You have forgot to set data-title");
			}

			/**
			 * Latitude of either embankment or key hill
			 */
			this.lat = parseFloat(this.map_el.dataset.lat);

			/**
			 * Longitude of either embankment of kill hill
			 */
			this.lng = parseFloat(this.map_el.dataset.lng);

			/** Where to center the map by default. */
			this.center_lat = parseFloat(this.map_el.dataset.centerLat);
			this.center_lng = parseFloat(this.map_el.dataset.centerLng);

			/** Name of main marker */
			this.title = this.map_el.dataset.title;

			//finding the initally selected categories
			let tabs = [];
			if(window.innerWidth > 1200) {
				tabs = this.map_el.parentElement.querySelectorAll('.tab.active')
			} else {
				tabs = document.querySelectorAll("input[name='tab-dropdown']:checked");
			}

			if(!tabs || tabs.length === 0) {
				throw new Error("map.js - Cannot find any tabs");
			}

			tabs.forEach(tab => {
				this.selected_categories.push(tab.value);
			})

			loadGoogleMapsApi({key: wordpress_globals.google_maps_api_key }).then(mapsApi => {
				this.api = mapsApi;
				this.infowindow = new mapsApi.InfoWindow({
					content: 'dsfdsfdsfs',
					closeBoxURL: ''
				});
				// console.log("Info window: ", this.infowindow);
				this.initialise_map();
			});

			await this.get_data();

			/**
			 * The data from the ACF blocks (JSON).
			 */
			// this.data = JSON.parse(this.map_el.getAttribute('data-markers'));

			/** The inital selected buttons */
			if(window.innerWidth > 1200) {
				/** When the user selects a new tab. */
				this.map_el.parentElement.querySelectorAll('.tab').forEach(tab => {
					tab.addEventListener('click', (e) => {
						document.activeElement.blur();
						if (!tab.classList.contains('active')) {
							// console.log("Category: ", tab.value);
							tab.classList.add('active');
						} else {
							tab.classList.remove('active');
						}

						let selected_tabs = [];
						//updating the selected categories.
						this.map_el.parentElement.querySelectorAll('.tab.active').forEach(active_tab => {
							selected_tabs.push(active_tab.value);
						})

						this.selected_categories = selected_tabs;

						this.draw_markers();
					})
				});
			} else {
				/** When tabs are changed mobile */
				let mobile_tabs = document.querySelectorAll("input[name='tab-dropdown']");
				mobile_tabs.forEach(input => {
					//when an input is changed get the new selected values.
					input.addEventListener('change', (e) => {
						let selected_tabs = [];
						document.querySelectorAll("input[name='tab-dropdown']:checked").forEach(selected_tab => {
							selected_tabs.push(selected_tab.value);

						});

						this.selected_categories = selected_tabs;
						this.draw_markers();
					})
				})
			}

			console.log("Data", this.data);
		}
	}

    get_data() {
    	let _this = this;
		let url = window.location.origin + "/wp-json/api/amenities";
			this.cats.forEach(async (cat) => {
				await axios.post(url, {
					cat: cat,
					loc: this.map_el.dataset.location,
					page: this.map_el.dataset.page,
				}).then(res => {
					if(!res.data.error) {
						_this.data[cat] = res.data;
						res.data.amenities.forEach(marker => {
							this.active_markers.push(this.create_HTML_marker(marker));
						})
					}
					console.log("Result: ", res);
				}, e => {
					console.log("Error: ", e)
				})
			})
	}


	/** Initalising the Google Map at the location defined in the map element. */
    initialise_map() {
    	let customStyle = [
			{
				featureType: "all",
				elementType: "labels",
				stylers: [
					{ visibility: "off" }
				]
			},
			{
			"featureType": "all",
				"elementType": "labels.icon",
				"stylers": [
					{
						"visibility": "off"
					}
				]
			},
			{
				"featureType": "administrative",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 17
					},
					{
						"weight": 1.2
					}
				]
			},
			{
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#35353b"
					},
					{
						"lightness": "-0"
					}
				]
			},
			{
				"featureType": "poi",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#212829"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.fill",
				"stylers": [
					{
						"color": "#7d7d7d"
					},
					{
						"weight": "2.86"
					}
				]
			},
			{
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [
					{
						"color": "#000000"
					},
					{
						"lightness": 29
					},
					{
						"weight": 0.2
					}
				]
			},
			{
				"featureType": "road.arterial",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#6a6a6a"
					},
					{
						"weight": ".5"
					}
				]
			},
			{
				"featureType": "road.local",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#565656"
					},
					{
						"weight": "0.36"
					}
				]
			},
			{
				"featureType": "transit",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#4c988f"
					},
					{
						"lightness": 19
					}
				]
			},
			{
				"featureType": "water",
				"elementType": "geometry",
				"stylers": [
					{
						"color": "#1bb7cb"
					},
					{
						"lightness": "-37"
					}
				]
			}
		];

        this.map = new this.api.Map(this.map_el, {
            center: {lat: this.center_lat, lng: this.center_lng},
            zoom: 14,
            mapTypeControl: false,
			streetViewControl: false,
			disableDoubleClickZoom: true,
			clickableIcons: false,
			styles: customStyle,
        })

		this.create_HTML_marker(undefined, true, this.title, this.lat, this.lng);
        // this.draw_markers();
    }

    draw_markers() {

		/**
		 * Remove previous markers from the screen and draw the newly selected categories.
		 */
		if(this.active_markers.length !== 0) {
			this.active_markers.forEach(marker => {
				marker.onRemove();
			})
		}
		this.active_markers = [];

		// let selected_markers = this.data[this.selected_category];
		let selected_markers_uncombined = [];
		this.selected_categories.forEach(selected_category => {
			if(this.data[selected_category] && this.data[selected_category].amenities) {
				selected_markers_uncombined.push(this.data[selected_category].amenities);
			}
		});


		let selected_markers = [];
		//if we have got any markers.
		if(selected_markers_uncombined.length > 0) {
			//combining all the active markers into 1.
			for(let i = 0; i < selected_markers_uncombined.length; i++) {
				for(let j = 0; j < selected_markers_uncombined[i].length; j++) {
					selected_markers.push(selected_markers_uncombined[i][j]);
				}
			}
		}

		console.log("Selected markers uncombined: ", selected_markers_uncombined)
		// console.log("Selected category: ", this.selected_category)
		console.log("Selected markers: ", selected_markers);


		selected_markers.forEach(marker => {
			this.active_markers.push(this.create_HTML_marker(marker));
		});
    }

    /**
	 * @param {*} marker The marker
	 * @param {boolean} main Whether this is the main map (just the 2 sliders) or the category tab map.
	 * @param {float} lat Latitude for marker
	 * @param {float} lng Longitude for marker
	 */
	create_HTML_marker(marker, main = false, name, lat, lng) {
		let that = this;
		function HTMLMarker(lat, lng) {
			this.lat = lat;
			this.lng = lng;
			this.setMap(that.map);
			this.pos = new google.maps.LatLng(lat,lng);
		}

		HTMLMarker.prototype = new google.maps.OverlayView();
		HTMLMarker.prototype.onRemove= function(){
			if (this.div) {
				this.div.parentNode.removeChild(this.div);
				this.div = null;
				this.setMap(null);
			}
		}

		//init your html element here
		HTMLMarker.prototype.onAdd= function(){
			var div = document.createElement('DIV');
			if(!main) {
				div.classList.add("marker_element");
				div.style.position='absolute';

				div.innerHTML = `
					<div tabindex="0" class = "marker ${marker.colour}">
						${marker.icon}
					</div>
					<div class="marker_content location-marker">
						<div class="arrow-container">
							<img class="lazyload arrow" src="/wp-content/themes/class/dist/images/icons/Left-marker.png" alt=""/>
						</div>
						${marker.images}
						<div class="content">
							<div class="title"><h4>${marker.title}</h4></div>
							<div class="distance">
								<img class="walking-man" src = "/wp-content/themes/class/dist/images/icons/Man.png" alt = "Distance icon"/>
								<p>${marker.distance}</p>
							</div>
						</div>
					</div>
				`;
				var panes = this.getPanes();
				panes.overlayMouseTarget.appendChild(div);

				let this_el = panes.overlayMouseTarget.childNodes[panes.overlayMouseTarget.childNodes.length - 1];

				let that = this;

				function toggle_marker(e) {
					document.querySelectorAll('.marker_content').forEach(content => {
						if(content !== e.target.nextElementSibling) {
							content.classList.remove('active');
							content.previousElementSibling.classList.remove('active');
						} else {
							content.classList.toggle('active');
							that.map.panTo(new google.maps.LatLng(that.lat, that.lng))
							if(window.innerWidth > 1200) {
								that.map.panBy(0, -100)
							}
							// that.map.setCenter(new google.maps.LatLng(this.lat + 0.0075,this.lng));
							content.previousElementSibling.classList.toggle('active')

							Swiper.use([Pagination, Navigation]);

							setTimeout(() => {
								// let pagination = this.map_el.querySelector('.marker-swiper .swiper-pagination')
								let swiper = new Swiper('.marker-swiper', {
									direction: 'horizontal',
									loop: true,
									allowTouchMove: false,
									pagination: {
										el: '.swiper-pagination',
										type: 'bullets',
										clickable: true
										// bulletElement: 'span'
									}
								})
							}, 100);
						}
					});
				}

				this_el.querySelector('.marker').addEventListener("keydown", (e) => {
					if(e.keyCode === 9) {
						document.querySelectorAll('.marker_content').forEach(content => {
							content.classList.remove('active');
							content.previousElementSibling.classList.remove('active');
						});
					}

					if(e.keyCode === 13) {
						//closing when tabbing.
						toggle_marker(e);
					}
				});


				this_el.querySelector('.marker').addEventListener("click", (e) => {
					toggle_marker(e);
				});

				document.addEventListener('click', (e) => {
					// console.log("Clicked: ", e.target);
					let container = $('.marker_element');
					let is_container = container.is(e.target);
					let has_container = container.has(e.target).length !== 0;

					// console.log("is container: " + is_container);
					// console.log("has container: " + has_container);

					if(!is_container && !has_container) {
						document.querySelectorAll('.marker_content').forEach(content => {
							content.classList.remove('active');
							content.previousElementSibling.classList.remove('active');
						})
					}
				});
			} else if(main && name && lat && lng) {
				div.classList.add('main_marker');
				div.style.position='absolute';
				div.innerHTML = `
					<div class = "marker">
						<img class="lazyload arrow" src="/wp-content/themes/class/dist/images/icons/bottom-marker.png" alt = ""/>
						<img class="lazyload icon" alt="${name}'s icon" src="${name === "Embankment" ? '/wp-content/themes/class/dist/images/icons/Embankment-Icon---Green.png' : '/wp-content/themes/class/dist/images/icons/Key-Hill-Icon---Orange.png'}" />
					</div>
				`;
				var panes = this.getPanes();
				panes.overlayMouseTarget.appendChild(div);
			}
			this.div = div;
		}

		HTMLMarker.prototype.draw = function(){
			var overlayProjection = this.getProjection();
			// this.div.removeAttribute("style");
			var position;
			position = overlayProjection.fromLatLngToDivPixel(this.pos);

			this.div.style.left = position.x + 'px';
			this.div.style.top = position.y + 'px';
			var panes = this.getPanes();
		}


		HTMLMarker.prototype.setPosition = function(position, rating = "All", type = "region") {
			var point;
			if(rating !== "All" && type === "la") {
				// this.latlng_ = position;
				point = this.getProjection().fromLatLngToDivPixel(position);
			} else {
				point = this.getProjection().fromLatLngToDivPixel(this.pos);
			}
			if (point) {
				this.pos = position
			}
        };

		let el;

		if(!main) {
			el = new HTMLMarker(marker.lat, marker.lng);
		} else if(main && name && lat && lng) {
			el = new HTMLMarker(lat, lng)
		}
		// el.setVisible(visible);
		el.setMap(this.map);

		// this.create_chart(id, data);
		return el;
	}
}
